<template>
  <div class="content-section no-padding" id="education-list-template">
		<!-- BEGIN FILTER WRAPPER -->
		<div class="mo-type">
			<div class="table-wrap new">
				<table>
					<caption class="sr-only">검색필터</caption>
					<colgroup>
						<col style="width:160px;">
						<col>
						<col style="width:160px;">
						<col>
					</colgroup>
					<tbody>
						<tr>
							<th scope="row">모집상태</th>
							<td>
								<div class="radio-group">
									<label class="radio-item" :for="'state_' + value" v-for="(key, value) in States" :key="value">
										<input type="radio" name="status" :value="value" v-model="educationSearchDto.state" :id="'state_' + value" @change="search" class="sr-only" title="status 선택">
										<span class="custom-radio" role="radio"></span>
										{{ key }}
									</label>
								</div>
              </td>
							<th scope="row">유/무료</th>
							<td>
								<div class="radio-group">
									<label class="radio-item" :for="'cost_' + value" v-for="(key, value) in Costs" :key="value">
										<input type="radio" name="costs" :value="value" v-model="educationSearchDto.cost" :id="'cost_' + value" @change="search" class="sr-only" title="costs 선택">
										<span class="custom-radio" role="radio"></span>
										{{ key }}
									</label>
								</div>
							</td>
            </tr>
            <tr v-if="['capacity', 'basic', 'groupCounsel', 'aiDigital', 'centerEducation', 'healthy'].includes(educationKind)">
              <th scope="row"><label for="select-institution">기관</label></th>
              <td colspan="3">
                <div class="input-area mo-size wid400">
                  <select aria-label="기관선택" required v-model="educationSearchDto.orgCode" @change="search" id="select-institution" title="기관선택">
                    <option value="ALL">전체 기관</option>
                    <option v-for="org in orgList" :key="org.code" :value="org.code">{{ org.name }}</option>
                  </select>
                </div>
              </td>
            </tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="search-form-top">
			<div class="input-group search">
				<div class="input-group-inner">
          <label for="search_input" class="sr-only">검색어 입력</label>
					<input type="text"
								 class="font-body-style3"
								 placeholder="검색어를 입력해 주세요."
                 v-model="educationSearchDto.term"
                 id="search_input"
                 @keyup.enter="search" title="검색어를 입력해 주세요." />
					<button type="button" class="btn-search" @click="search" title="검색 버튼">
						<i class="ico ico-search">
							<span class="ir-text">검색</span>
						</i>
					</button>
				</div>
			</div>
		</div>
		<!-- END FILTER WRAPPER -->
    <!-- BEGIN JOB-LIST-CONTAINER -->
    <edu-card-list-more-type :educationKind="educationKind" :educationSearchDto="educationSearchDto" ref="listComponent"></edu-card-list-more-type>
    <!-- END JOB-LIST-CONTAINER -->
  </div>
</template>

<script>
import EduCardListMoreType from '../components/EduCardListMoreType.vue';

const Types = {
  ALL: '전체',
  TITLE: '제목',
  LECTURER: '강사명',
  KEYWORD: '키워드',
};

const Costs = {
  ALL: '전체',
  FREE: '무료',
  CHARGED: '유료',
};

const States = {
  ALL: '전체',
  JOIN: '모집중',
  PEND: '모집예정',
};

export default {
  name: 'education-list-template',
  props: ['educationKind', 'orgList', 'searchDto'],
  components: {
    EduCardListMoreType,
  },
  data() {
    return {
      educationSearchDto: {
        state: this.searchDto.state || 'ALL',
        cost: this.searchDto.cost || 'ALL',
        term: this.searchDto.term,
        type: this.searchDto.type || 'ALL',
        orgCode: this.searchDto.orgCode || 'ALL',
      },
      Types,
      Costs,
      States,
    };
  },
  computed: {},
  watch: {},
  methods: {
    search() {
      this.$refs.listComponent.searchData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// EducationList.vue?5970b3e8